import React from 'react';

import { SVGProps } from './SVGProps';

const DashboardFileIcon = ({ fill = '#101828', width = '24', height = '25' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 11.1367H8M10 15.1367H8M16 7.13672H8M20 6.93672V17.3367C20 19.0169 20 19.857 19.673 20.4987C19.3854 21.0632 18.9265 21.5221 18.362 21.8097C17.7202 22.1367 16.8802 22.1367 15.2 22.1367H8.8C7.11984 22.1367 6.27976 22.1367 5.63803 21.8097C5.07354 21.5221 4.6146 21.0632 4.32698 20.4987C4 19.857 4 19.0169 4 17.3367V6.93672C4 5.25656 4 4.41648 4.32698 3.77475C4.6146 3.21026 5.07354 2.75132 5.63803 2.4637C6.27976 2.13672 7.11984 2.13672 8.8 2.13672H15.2C16.8802 2.13672 17.7202 2.13672 18.362 2.4637C18.9265 2.75132 19.3854 3.21026 19.673 3.77475C20 4.41648 20 5.25656 20 6.93672Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DashboardFileIcon;
